import { ROUTE_NAMES } from './routeNames.const'

export const routeEndOfCircuit = {
  path: '/end-of-circuit',
  name: ROUTE_NAMES.endOfCircuit,
  component: () =>
    import(
      /* webpackChunkName: "EndOfCircuit" */ 'src/components/common/EndOfCircuit/EndOfCircuit.vue'
    ),
  props: true,
  meta: {
    headerWithoutAction: true,
  },
}
